export default __webpack_public_path__ + "static/media/hht2_ep08_timeline_q04_a.c4fc6ae6.png";